import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const StyledFieldset = styled.fieldset.withConfig({ displayName: "auir-611444a-StyledFieldset", componentId: "auir-611444a-2x33ah" }) `
  margin: 0;
  padding: 0;

  border: 0;

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=FormGroup.styles.mjs.mjs.map